// @flow

export const SEEDS_DRILLING_FILE_TYPE = 'seeds.drilling';

export const ConstantsImport = {
    import: {
        public: '/api/public/',
        opunits: {
            list: 'opunits/'
        },
        oilField: {
            list: 'oilfields/'
        },
        well: {
            list: 'wells/'
        },
        file: {
            list: 'files/'
        },
        config: {
            baseUrl: '/services/plugin-pocoweb/wellimport/',
            read: 'configlist',
            importPart: 'importpart',
            fileType: 'files/?file_type=',
            attachment: 'attachment'
        }
    },
    msg: {
        needInstance: 'Need to register at least one import instance in configuration',
        onlyLocal: 'Only local connections are allowed',
        notConnect: 'Could not request the configured resource',
        genericError: 'There was an error while importing',
        notFound: 'Could not found the requested file',
        noResults: 'No results found',
        permission: 'Need permissions to import data'
    },
    adminUrl: 'admin/#/integrations/liverig-pocoweb-wellimport',
    emptyWellFileImport: {
        description: {},
        location: {},
        lithology: {
            ages: [],
            comments: [],
            formations: [],
            hc_porous_formations: [],
            inclined_formations: [],
            rocks: []
        },
        sections: {
            sections: []
        },
        pressures: {
            fracture: [],
            pore: []
        },
        trajectory: {
            trajectory: []
        },
        temperatures: {
            water_depth: [],
            profile: []
        },

        restore: {
            description: {},
            location: {},
            sections: {
                sections: []
            },
            pressures: {},
            trajectory: {},
            temperatures: {}
        },

        imported: false,
        restored: false,

        wellCard: {}
    },
    wellInterventionFileTypes: [
        // perfuração
        SEEDS_DRILLING_FILE_TYPE,
        'dadosbasicos.drilling',
        // completação
        'seeds.completion',
        'dadosbasicos.completion',
        // avaliação
        'seeds.assessment',
        'dadosbasicos.assessment',
        // executado
        'seeds.asbuilt',
        'dadosbasicos.asubilt'
    ],
    attachmentTypes: [
        'csb.ncsb', 
        // 'seeds.assessment'
    ]
}

export const importErrors = {
    needregister: {
        error: {
            msg: ConstantsImport.msg.needInstance,
            type: 'needregister'
        }
    }
}
